import { createActions } from 'redux-actions'

export const INIT_BRAND_INFO = "INIT_BRAND_INFO";

export const REQUEST_BRAND_START = "REQUEST_BRAND_START";
export const REQUEST_BRAND_SUCCESS = "REQUEST_BRAND_SUCCESS";
export const REQUEST_BRAND_FAIL = "REQUEST_BRAND_FAIL";

export const {

  initBrandInfo,
  requestBrandStart,
  requestBrandSuccess,
  requestBrandFail,

} = createActions({

  [INIT_BRAND_INFO]: (req) => ({ req }),

  [REQUEST_BRAND_START]: (req) => ({ ...req }),
  [REQUEST_BRAND_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRAND_FAIL]: (res) => ({ res }),

})


